import { h } from "preact";
import ModalStore from "./components/modal/store";
import Modal from "./components/modal";

export default function App(props) {
  const modal = new ModalStore(props);
  return (
    <Modal store={modal}/>
  );
}

